import http from '@/support/plugin/axios'

export const 

//Pega todas as informações da tela
getContactInfoByCurrentIdAndCompanyId = ( companyId ) => http.get(`companies/${companyId}/contacts/current`),

//Editar informações do form do profile
updateContactByCurrentId = ( profileObject ) => { 

    const body = {
        cpf: profileObject.cpf,
        birthday: profileObject.birthday,
        email: profileObject.email,
        genderId: profileObject.genderId,
        name: profileObject.name,
        telephone: profileObject.telephone,
        cidade: profileObject.cidade,
        cidadenome: profileObject.cidadenome
    }

    return http.put('contacts/current', body)
},

//Editar imagem do profile
updateImageByCurrentContactId = ( image ) => http.patch('contacts/current/image', image),

// buscarCidadeIntegracao = (search ) => http.get(`sankhya/cities?search=${search}`),
buscarCidadeIntegracao = (estado, search ) => http.get(`/city/stateId?stateId=${estado}&search=${search}`), 
buscarEstado = () => http.get(`/state`),
//Switch do email
updateEmailSubscriptionByCurrentIdAndCompanyId = ( companyId, enabled ) => {
    const body = {
        enabled: enabled
    }
    
    return http.patch(`companies/${companyId}/contacts/current/email-subscription`, body)
},

//Switch do sms
updateSmsSubscriptionByCurrentIdAndCompanyId = ( companyId, enabled ) => {
    const body = {
        enabled: enabled
    }

    return http.patch(`companies/${companyId}/contacts/current/sms-subscription`, body)
},

//Pegar imagem do usuário
getImageByCurrentId = () => http.get('contacts/current/image'),

//Vincular facebook
updateFacebookAccessTokenByCurrentContactId = ( accessToken ) => {
    const body = {
        accessToken: accessToken
    }

    return http.patch('contacts/current/facebook-access-token', body)
},

//Desvincular facebook
deleteFacebookAccessTokenByCurrentContactId = () => http.delete('contacts/current/facebook-access-token'),

//Confirmação de e-mail
sendConfirmationEmailByCompanyIdAndCurrentId = ( companyId ) => http.patch(`companies/${companyId}/contacts/current/email-confirmation`, null)